import { type ReactElement, type ReactNode, useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/app/store";
import searchImage from "../../../../assests/Icons/search.svg"
import { getUsers, getUsersByDealerId } from "../../hooks/userResponsibility";
import { createUser, updateUser } from "../../hooks/addUpdateUserResponsibility";
import { getUserById } from "../../hooks/userResponsibility";
import { getPasswordProfiles } from "../../hooks/passwordProfileResponsibility";
import Button from "src/components/Button"
import UserModal from "./UserModal";
import UserList from "./UserList";
import { UserType } from "../../types/UserType";
import { getDealers } from "src/features/admin/hooks/dealers";
import Spinner from "src/components/Spinner";
import { userReset } from "../../hooks/addUpdateUserResponsibility";
import { getEndUsersByDealerID } from "src/features/dealers/hooks/endUsers";

export interface UserMainProps {
        children?: ReactNode;
        dealerId: string;
}

const initialUser: UserType = {
        Id: 0,
        FirstName: "",
        LastName: "",
        EmailId: "",
        Password: "",
        PhoneNumber: "",
        Registered: false,
        PrimaryUser: false,
        UserType: "",
        DealerId: 0,
        PasswordProfileId: 0,
        Notes: "",
        Enabled: false,
        CreatedAt: "",
        ModifiedAt: "",
        UserAccesses: []
}

export default function UserManagementMain(props: UserMainProps): ReactElement {
        const [isModalOpen, setModalOpen] = useState(false);
        const [modalTitle, setModalTitle] = useState("");
        const [selectedUser, setUser] = useState<UserType | undefined>(initialUser);
        const dispatch = useDispatch<AppDispatch>();
        const { users, usersLoading, usersError } = useSelector((state: RootState) => state.users);
        const { user, userLoading, userError } = useSelector((state: RootState) => state.user);
        const { dealers, dealersLoading } = useSelector((state: RootState) => state.dealers);
        const { dealer, dealerLoading } = useSelector((state: RootState) => state.dealer);
        const { authUser, authLoading } = useSelector((state: RootState) => state.auth);
        const { passwordProfileLoading, passwordProfiles } = useSelector((state: RootState) => state.passwordProfiles);

        const AddUser = () => {
                setModalOpen(true);
                setModalTitle("Add User");
                setUser(initialUser);
        }

        const userClicked = (event: React.MouseEvent<HTMLDivElement>) => {
                const id = parseInt(event.currentTarget.id);
                setModalOpen(true);
                setModalTitle("Edit User");
                let user = users.find((a) => a.Id === id);
                setUser(user);
        }

        const Filter = () => {
                console.log("Adding user");
        }

        const CloseModal = () => {
                setModalOpen(false);
                if (user?.Id !== undefined) {
                        dispatch(getUserById(user?.Id));
                }
                dispatch(userReset());
        }

        useEffect(() => {
                if (authUser?.UserType === "admin") {
                        dispatch(getUsers(""));
                        dispatch(getDealers(""));
                        dispatch(getPasswordProfiles(""));
                }
                else {
                        dispatch(getUsersByDealerId(dealer.Id));
                        dispatch(getPasswordProfiles(""));
                }
        }, [])

        return <>
                {!usersLoading && !passwordProfileLoading && ((authUser?.UserType === "admin") ? !dealersLoading : (true)) ?
                        (
                                <div className="grid grid-rows-[1fr_19fr] flex-[1_1_auto] gap-2">
                                        <div className="place-content-between flex flex-auto gap-4">
                                                <div className="flex basis-full bg-white">
                                                        <img className="p-2" src={searchImage} alt="" />
                                                        <input className="w-full hover:border-black" type="text" />
                                                </div>
                                                <Button className="basis-1/2" size="sm" type="button" buttonStyle="primary" handleClick={Filter}>Filter</Button>
                                                <Button className="basis-1/2" size="sm" type="button" buttonStyle="primary" handleClick={AddUser}>Add User</Button>
                                        </div>

                                        <UserList userList={users} userClick={userClicked} />
                                        {(isModalOpen && !passwordProfileLoading) ?
                                                <UserModal title={modalTitle} passwordProfiles={passwordProfiles} selectedUser={selectedUser} isOpen={isModalOpen} onClose={CloseModal} />
                                                :
                                                <></>
                                        }
                                </div>
                        )
                        :
                        <Spinner title="Loading" />
                }
        </>
}
